import * as yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX, messages } from 'app/config/constants';

export const caseFileInspectionSchema = () => yup.object({
  webId: yup
    .string()
    .required(messages.MANDATORY_FIELD)
    .matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!'),
  fileInsightPassword: yup.string().required(messages.MANDATORY_FIELD),
})
